import React from 'react';

import { Link } from '@mui/material';

import classes from './Footer.module.scss';
import {
  stripePrivacyPolicyLink,
  stripeTermsOfUseLink,
} from '../../../constants/externalLinks';
import StripeLogo from '../../../../shared/assets/image/stripe-logo.svg';

const Footer = () => {
  return (
    <div className={classes.container}>
      <div className={classes.logo}>
        <p>Powered by</p>
        <img src={StripeLogo} alt="stripe_logo" />
      </div>
      <div className={classes.privacyLinks}>
        <Link className={classes.link} href={stripeTermsOfUseLink}>
          Terms
        </Link>
        <p>·</p>
        <Link className={classes.link} href={stripePrivacyPolicyLink}>
          Policy
        </Link>
      </div>
    </div>
  );
};

export { Footer };
